import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Spinner({ className }: { className?: string }): JSX.Element {
  return <Loader2 className={cn('size-4 animate-spin', className)} aria-hidden="true" />;
}

/** Full-region loading state with an accessible label. */
export function LoadingRegion({ label = 'Loading' }: { label?: string }): JSX.Element {
  return (
    <div
      className="text-muted-foreground flex items-center justify-center gap-2 p-10 text-sm"
      role="status"
    >
      <Spinner />
      <span>{label}…</span>
    </div>
  );
}
